module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "append-to-body": "",
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "width": _vm.imageWidth + 'px'
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    ref: "form"
  }, [_c('el-form-item', [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.image
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ed9e644","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageShow.vue
// module id = 759
// module chunks = 2